var exports = {
  "iE": "xaf9ae18d--f0b983--wrapper",
  "Sl": "xaf9ae18d--f0b983--image",
  "Zm": "xaf9ae18d--f0b983--newbuilding-image",
  "pr": "xaf9ae18d--f0b983--developer-logo",
  "Qs": "xaf9ae18d--f0b983--content",
  "DD": "xaf9ae18d--f0b983--title",
  "hl": "xaf9ae18d--f0b983--address",
};

module.exports = exports;
